import React, { Component } from 'react'
import './Modal.css'
import { Action } from '../commons/Actions'

class Modal extends Component {
  componentDidMount () {
    document.body.style.overflow = 'hidden'
  }
  componentWillUnmount () {
    document.body.style.overflow = 'visible'
  }
  render () {
    let className = 'modal'
    if (this.props.size === 'small') {
      className += ' modal--sm'
    } else if (this.props.size === 'large') {
      className += ' modal--lg'
    }
    return (
      <div className={className}>
        <div className='modal__overlay' />
        <div className='modal__window'>
          <div className='modal__header'>
            <div className='modal__header__title'>{this.props.title}</div>
            <div className='modal__header__actions'>
              <Action color icon='close' onClick={this.props.handleClose} />
            </div>
          </div>
          <div className='modal__body'>
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}

export default Modal
